// TODO: Legacy MobX Store, need to migrate remaining stores and methods to ./mst
class GlobalStore {
}

export default GlobalStore;
